import { ProductSectorMappingStatus, SectorStatus } from 'api'
import { Translation } from 'locale'

import * as constants from 'view/styles/constants'

export function getDraftMappingStatusColor(sectorMappingEvent: ProductSectorMappingStatus) {
  switch (sectorMappingEvent) {
    case ProductSectorMappingStatus.EDITED:
      return constants.STATUS_COLOR_RESPOND

    case ProductSectorMappingStatus.EXISTING:
      return constants.STATUS_COLOR_ACCEPTED

    case ProductSectorMappingStatus.DELETED:
      return constants.STATUS_COLOR_URGENT

    default:
      return 'initial'
  }
}

export function getSectorStatusColor(sectorMappingEvent: SectorStatus) {
  switch (sectorMappingEvent) {
    case SectorStatus.ENABLED:
      return constants.STATUS_COLOR_ACCEPTED

    case SectorStatus.DELETED:
      return constants.STATUS_COLOR_URGENT

    default:
      return 'initial'
  }
}

export const sectorStatusTranslationMap = {
  [SectorStatus.ENABLED]: Translation.TC_ENABLED,
  [SectorStatus.DISABLED]: Translation.TC_DISABLED,
  [SectorStatus.DELETED]: Translation.TC_DELETED
}

export const sectorStatusTranslationReverseMap = {
  [Translation.TC_ENABLED]: SectorStatus.ENABLED,
  [Translation.TC_DISABLED]: SectorStatus.DISABLED,
  [Translation.TC_DELETED]: SectorStatus.DELETED
}
